import React, { useEffect } from 'react';
import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import EmployeeLoginFlow from './Login/EmployeeLoginFlow';
import { DevelopmentTool, useNeuroMessages } from '../../components';
import {useDispatch, useNeuroState} from '../../state';
import { getMessages } from '../../utils/helpers/messageHelper';
import {checkIfEmployeeIsLoggedIn} from '../state/Login/LoginActions';
import {useGuideConfig, usePages} from '../../hooks';
/**
 * Common container for the neuro-app to provide a consistent structure for
 * classnames based on the state of the app. Also requires the consumer to use an
 * ErrorBoundary
 */
const GuideAppContainer = ({ children, className, useDevelopmentTool = true, useToast = true }) => {
  const { employeeLoginState } = useNeuroState();
  const { savedPages, isLoadingNextPage } = usePages();
  const { isBranchGuide } = useGuideConfig();
  const dispatch = useDispatch();
  const location = useLocation();
  const messageContext = useNeuroMessages();
  const currentPage = savedPages && savedPages[location.pathname] || {};
  const loginFlowEnabled = employeeLoginState?.loginFlowEnabled;

  //check if employee is logged in for a branch guide
  useEffect(() => {
    isBranchGuide && dispatch(checkIfEmployeeIsLoggedIn());
  }, []);

  //function to set the document title if message is found for it.
  useEffect(() => {
    if (currentPage?.path) {
      const messageId = `title.${currentPage.id || currentPage.path}`;
      const messageValue = messageContext.getMessage(messageId) || messageContext.getMessage('title.default');

      messageValue && (document.title = messageValue);
    }
  }, [currentPage]);

  const getAppPageTypeModifier = () => {
    let result = '';
    const pathname = location.pathname;
    if (pathname === '/guide') {
      result = 'app--landingPage';
    } else if (pathname.includes('spa')) {
      result = 'app--surveyPage';
    } else if (pathname.includes('summary')) {
      result = 'app--summaryPage';
    } else if (pathname.includes('details')) {
      result = 'app--detailsPage';
    }
    return result;
  };

  const pathName = currentPage.path ? currentPage.path.key : '';
  const pageName = currentPage.page ? currentPage.page.key : '';
  const appClasses = classnames(
    'app',
    getAppPageTypeModifier(location.pathname),
    className,
    {
      [`app--path-${pathName}`]: pathName,
      [`app--page-${pageName}`]: pageName,
      ['app--processing']: isLoadingNextPage,
    }
  );

  return (
    <div className={appClasses}>
      { loginFlowEnabled && isBranchGuide && <EmployeeLoginFlow messages={getMessages(messageContext.locale)} /> }
      {children}
      {useDevelopmentTool && <DevelopmentTool />}
      {useToast && <ToastContainer />}
    </div>
  );
};

GuideAppContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  useDevelopmentTool: PropTypes.bool,
  useToast: PropTypes.bool,
};
export default GuideAppContainer;
